import { EmailRecipientsPage } from "./EmailRecipientsPage";

export default EmailRecipientsPage;
